import React, { useState, useEffect } from 'react';
import { 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    TextField, 
    Button, 
    Typography,
    Box,
    Snackbar,
    Alert
} from '@mui/material';
import { sendPasswordResetEmail, getUserProfile, updateUserProfile } from '../services/userService';

const ProfileDialog = ({ open, onClose }) => {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [role, setRole] = useState('');
    const [jobFunction, setJobFunction] = useState('');
    const [isGoogleUser, setIsGoogleUser] = useState(false);
    const [showToast, setShowToast] = useState(false);

    useEffect(() => {
        const fetchUserProfile = async () => {
            const userProfile = await getUserProfile();
            if (userProfile) {
                setEmail(userProfile.email);
                setName(userProfile.name || '');
                setRole(userProfile.role || '');
                setJobFunction(userProfile.jobFunction || '');
                setIsGoogleUser(userProfile.isGoogleUser);
            }
        };
        fetchUserProfile();
    }, []);

    const handleUpdatePassword = async () => {
        await sendPasswordResetEmail(email);
        setShowToast(true);
        onClose();
    };

    const handleSaveProfile = async () => {
        await updateUserProfile({ name, role, jobFunction });
        onClose();
    };

    const handleCloseToast = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setShowToast(false);
    };

    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
                <DialogTitle>Profile Management</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="body1">Email: {email}</Typography>
                        {isGoogleUser && (
                            <Typography 
                                variant="body2" 
                                color="text.secondary" 
                                sx={{ ml: 1 }}
                            >
                                (Registered using Google)
                            </Typography>
                        )}
                    </Box>
                    
                    {!isGoogleUser && (
                        <Button 
                            onClick={handleUpdatePassword}
                            variant="outlined"
                            sx={{ 
                                mb: 2,
                                textTransform: 'none',
                                borderColor: '#2D68FE',
                                color: '#2D68FE',
                                '&:hover': {
                                    borderColor: '#2D68FE',
                                    backgroundColor: 'rgba(45, 104, 254, 0.04)'
                                }
                            }}
                        >
                            Update Password
                        </Button>
                    )}
                    
                    <TextField
                        label="Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        fullWidth
                        margin="normal"
                    />
                    <TextField
                        label="Role"
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                        fullWidth
                        margin="normal"
                    />
                    <TextField
                        label="Job Function"
                        value={jobFunction}
                        onChange={(e) => setJobFunction(e.target.value)}
                        fullWidth
                        margin="normal"
                    />
                </DialogContent>
                <DialogActions sx={{ p: 2.5, pt: 0 }}>
                    <Button 
                        onClick={onClose}
                        sx={{ 
                            textTransform: 'none',
                            color: '#2D68FE',
                            '&:hover': {
                                backgroundColor: 'rgba(45, 104, 254, 0.04)'
                            }
                        }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleSaveProfile}
                        variant="contained"
                        sx={{ 
                            textTransform: 'none',
                            backgroundColor: '#2D68FE',
                            '&:hover': {
                                backgroundColor: '#2D68FE'
                            }
                        }}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar 
                open={showToast} 
                autoHideDuration={6000} 
                onClose={handleCloseToast}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert 
                    onClose={handleCloseToast} 
                    severity="success" 
                    sx={{ width: '100%' }}
                >
                    Password reset email has been sent successfully!
                </Alert>
            </Snackbar>
        </>
    );
};

export default ProfileDialog;
